var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.serverError500)?_c('div',{staticClass:"alert cursor-pointer",on:{"click":_vm.closeAlert}},[_vm._v("SERVER ERROR!")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }